import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64a843e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-footer" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("关闭")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_VEselect = _resolveComponent("VEselect")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.addOrEditDialog,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.addOrEditDialog) = $event)),
    "custom-class": "FormDialogBox",
    width: "900px",
    title: _ctx.addOrEditTypeTitle[_ctx.addOrEditType],
    onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addOrEditCancel()))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          type: "danger",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addOrEditDialog = false))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          loading: _ctx.determineBtnLoading,
          type: "primary",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addOrEditDetermine()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.addOrEditTypeTitle[_ctx.addOrEditType]), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        class: "addForm",
        model: _ctx.addOrEditForm,
        rules: _ctx.addOrEditRules,
        ref: "addOrEditFormRef",
        "label-width": "auto"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "项目名称",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.addOrEditForm.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.addOrEditForm.name) = $event)),
                placeholder: "请输入项目名称",
                clearable: "",
                disabled: _ctx.addOrEditType === 1
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "项目类型",
            prop: "type_id"
          }, {
            default: _withCtx(() => [
              (_ctx.addOrEditDialog)
                ? (_openBlock(), _createBlock(_component_VEselect, {
                    key: 0,
                    selectValue: _ctx.addOrEditForm.type_id,
                    "onUpdate:selectValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.addOrEditForm.type_id) = $event)),
                    apiUrl: ['typeManagement', 'getList'],
                    placeholder: "请选择项目类型",
                    queryName: "name",
                    objLabel: "name",
                    objKey: "id",
                    selectedObj: _ctx.addOrEditForm.typeSelectedObj
                  }, null, 8, ["selectValue", "selectedObj"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "项目代号",
            prop: "code"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.addOrEditForm.code,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.addOrEditForm.code) = $event)),
                placeholder: "请输入项目代号",
                clearable: "",
                disabled: _ctx.addOrEditType === 1
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "项目负责人",
            prop: "user_id_type1"
          }, {
            default: _withCtx(() => [
              (_ctx.addOrEditDialog)
                ? (_openBlock(), _createBlock(_component_VEselect, {
                    key: 0,
                    selectValue: _ctx.addOrEditForm.user_id_type1,
                    "onUpdate:selectValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.addOrEditForm.user_id_type1) = $event)),
                    apiUrl: ['members', 'getList'],
                    placeholder: "请选择项目负责人",
                    queryStatus: 1,
                    queryName: "username",
                    objLabel: "username",
                    objKey: "user_id",
                    selectedObj: _ctx.addOrEditForm.userIdType1SelectedObj
                  }, null, 8, ["selectValue", "selectedObj"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "项目成员",
            prop: "user_ids_type2"
          }, {
            default: _withCtx(() => [
              (_ctx.addOrEditDialog)
                ? (_openBlock(), _createBlock(_component_VEselect, {
                    key: 0,
                    selectValue: _ctx.addOrEditForm.user_ids_type2,
                    "onUpdate:selectValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.addOrEditForm.user_ids_type2) = $event)),
                    apiUrl: ['members', 'getList'],
                    placeholder: "请选择项目成员",
                    multiple: "",
                    queryStatus: 1,
                    queryName: "username",
                    objLabel: "username",
                    objKey: "user_id",
                    selectedObj: _ctx.addOrEditForm.userIdType2SelectedObj
                  }, null, 8, ["selectValue", "selectedObj"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "项目时间段：",
            prop: "date"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.addOrEditForm.date,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.addOrEditForm.date) = $event)),
                "range-separator": "至",
                type: "daterange",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                clearable: "",
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "项目描述",
            prop: "describe",
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.addOrEditForm.describe,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.addOrEditForm.describe) = $event)),
                type: "textarea",
                rows: 5,
                placeholder: "请输入项目描述",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}